/** The handler's desk, shared by the Difficulty and Case steps. */
import type { CSSProperties } from "react";
import veronicaDesk from "./veronica-desk.jpg";
import dariusDesk from "./darius-desk.jpg";
import noHandlerDesk from "./no-handler-desk.jpg";
import veronicaNotYet from "./veronica-not-yet.jpg";
import dariusNotYet from "./darius-not-yet.jpg";
import noHandlerNotYet from "./no-handler-not-yet.jpg";

/** The handler sat behind the desk, keyed by the name picked on the Handler step. */
const DESKS: Record<string, string> = {
  veronica: veronicaDesk,
  darius: dariusDesk,
};

/** DeskImage is the authoring override; otherwise the desk follows the
 *  handler. No handler yet (missions 1-3): the room with the agent working at
 *  the back. */
export const deskFor = (handler: string | null, override?: string) =>
  override ||
  (handler ? DESKS[handler.toLowerCase()] || veronicaDesk : noHandlerDesk);

/** The handler turned round to face them, same framing as their desk shot
 *  (waving the sealed case off; sending them out on the clock). */
const NOT_YET: Record<string, string> = {
  veronica: veronicaNotYet,
  darius: dariusNotYet,
};
export const notYetFor = (handler: string | null) =>
  handler ? NOT_YET[handler.toLowerCase()] || veronicaNotYet : noHandlerNotYet;

/**
 * The desk photos are all 944x1666, drawn object-cover and bottom-anchored.
 * This box is exactly where that puts the photo — as wide as the frame or as
 * wide as the height demands, whichever is larger — so anything laid out in
 * its percentages (and its cqw) stays pinned to the same spot in the picture
 * on a phone, a tablet or a desktop.
 */
export const PHOTO_BOX: CSSProperties = {
  width: "max(100%, calc(100dvh * 944 / 1666))",
  aspectRatio: "944 / 1666",
};

/** In photo coordinates (see PHOTO_BOX): where the speech bubble sits and
 *  where its tail points, off the speaker's mouth (the bubble has a fixed
 *  width so the tail's percentage lands on the mouth whatever the line). */
export const bubbleFor = (handler: string | null) =>
  !handler
    ? { top: "28%", tailLeft: "68%" }
    : handler.toLowerCase() === "darius"
      ? { top: "26%", tailLeft: "50%" } // his photo sits higher in the frame
      : { top: "36%", tailLeft: "50%" };

/** In photo coordinates: where the desk's near surface starts (the files'
 *  band). The no-handler photo has more desk; Darius's sits higher. */
export const deskTopFor = (handler: string | null) =>
  !handler ? "36%" : handler.toLowerCase() === "darius" ? "40%" : "50%";
